import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface GlobalFooterProps {
  className?: string;
  variant?: "default" | "compact";
}

/**
 * Documentation §10 — global footer present on every page, identical for all
 * roles and contexts. Links: FAQ, Rules, About.
 */
export function GlobalFooter({ className, variant = "default" }: GlobalFooterProps) {
  return (
    <footer
      className={cn(
        "border-t border-[#e2e8f0] bg-white text-[13px] text-[#6c757d] no-print",
        variant === "compact" ? "py-4" : "py-6",
        className,
      )}
    >
      <div className="mx-auto flex w-full max-w-[1200px] flex-wrap items-center justify-between gap-4 px-4">
        <p className="text-[12px] tracking-wide text-[#94a3b8]">
          Finally · People work with people
        </p>
        <nav className="flex flex-wrap items-center gap-5 text-[13px]">
          <FooterLink to="/faq">FAQ</FooterLink>
          <FooterLink to="/rules">Rules</FooterLink>
          <FooterLink to="/about">About</FooterLink>
        </nav>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }: { to: string; children: string }) {
  return (
    <Link to={to} className="text-[#475569] hover:text-[#2563eb] transition-colors">
      {children}
    </Link>
  );
}
